import { h } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'
import { attributesAnalytics } from '../../js/modules/component'

const VIDEO = {
   url: 'https://hporange.cdn.s.woopic.com/habillage-test/CDM2026.mp4',
   url_mobile: 'https://hporange.cdn.s.woopic.com/habillage-test/Composition%206_1.mp4',
}
const maskImage = {
   url: 'https://hporange.cdn.s.woopic.com/habillage-test/1920-pluszoom-image-transparente.png',
   url_mobile: 'https://hporange.cdn.s.woopic.com/habillage-test/1920-pluszoom-image-transparente_mobile.png',
}

export const HabillageFond = ({ backgroundImage = '', image = '', alt, URL, analytics, cacheKey, display = true, video = VIDEO }) => {
   const [isVisible, setIsVisible] = useState(display)
   const [videoSource, setVideoSource] = useState(video ? (window.innerWidth > 480 ? video?.url : video?.url_mobile) : '')
   const videoRef = useRef(null)

   useEffect(() => {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)

      const handleSG1event = (event) => {
         setIsVisible(event.detail.display)
      }

      window.addEventListener('SG1event-habillage', handleSG1event)

      // Supprimer le scroll horizontal causé par la video
      if (video) {
         document.body.style.overflowX = 'hidden'
      }

      // Page resize
      //   const handleResize = () => {
      //      if (!video) return
      //      setVideoSource(window.innerWidth > 480 ? video?.url : video?.url_mobile)
      //      videoRef.current?.load() // Reload the video with the new source
      //   }
      //   window.addEventListener('resize', handleResize)

      return () => {
         window.removeEventListener('SG1event-habillage', handleSG1event)
      }
   }, [])

   return (
      <div class={`habillage-fond${!image ? ' no-front-image' : ''}`} key={cacheKey} style={{ display: isVisible ? 'block' : 'none' }}>
         {/* <div class="background-image">
            <img src={backgroundImage} class="background-main-image" alt={alt} />
         </div> */}
         {/* <div class="front-image" style={{ backgroundImage: `url(${image})` }}></div> */}
         {video !== '' && (
            <div class="front-video">
               <video
                  ref={videoRef}
                  aria-label=""
                  autoplay="autoplay"
                  loop="loop"
                  muted
                  preload="auto"
                  tabIndex="-1"
                  playsinline // mobile: evite le fullscreen
               >
                  <source src={videoSource} type="video/mp4" />
               </video>
            </div>
         )}
         <div class="mask-image">
            <picture>
               <source srcset={maskImage.url_mobile} media="(max-width: 480px)" />
               <img src={maskImage.url} alt="" />
            </picture>
         </div>
         <a class="banner-link" href={URL} {...attributesAnalytics(analytics)}></a>
      </div>
   )
}
